"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return RowColorCondition;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _ncError = require("~/helpers/ncError");
const _cli = require("~/cli");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const logger = new _common.Logger('RowColorCondition');
let RowColorCondition = class RowColorCondition {
    static async getById(context, id, ncMeta = _Noco.default.ncMeta) {
        const condition = await ncMeta.metaGet(context.workspace_id, context.base_id, _cli.MetaTable.ROW_COLOR_CONDITIONS, id);
        if (condition) {
            return new RowColorCondition(condition);
        } else {
            return undefined;
        }
    }
    static async getByViewId(context, fk_view_id, ncMeta = _Noco.default.ncMeta) {
        return (await ncMeta.metaList2(context.workspace_id, context.base_id, _cli.MetaTable.ROW_COLOR_CONDITIONS, {
            condition: {
                fk_view_id
            }
        })).map((row)=>new RowColorCondition(row));
    }
    static async delete(context, id, ncMeta = _Noco.default.ncMeta) {
        const ncMetaTrans = await ncMeta.startTransaction();
        try {
            await ncMetaTrans.metaDelete(context.workspace_id, context.base_id, _cli.MetaTable.ROW_COLOR_CONDITIONS, {
                id: id
            });
            await ncMetaTrans.metaDelete(context.workspace_id, context.base_id, _cli.MetaTable.FILTER_EXP, {
                fk_row_color_condition_id: id
            });
            await ncMetaTrans.commit();
        } catch (ex) {
            await ncMetaTrans.rollback();
            if (ex instanceof _ncError.NcError || ex instanceof _nocodbsdk.NcBaseError) throw ex;
            logger.error('Failed to remove Row Colouring', ex);
            _ncError.NcError.get(context).internalServerError('Failed to remove Row Colouring');
        }
    }
    constructor(data){
        Object.assign(this, data);
    }
};
